/* tz-hover-qa: relocate the Wishlist King heart (<wishlist-button-collection>)
   into the .tz-hover-qa anchor inside each .product-item card, so
   component-product-item.css can pin it bottom-left of the card image
   (all viewports). Re-runs via MutationObserver because the app
   re-injects buttons and sets an inline JS-computed transform.
   tz-wkp-cls: also toggles the .tz-wkp-loaded class on the product-page
   .flex-buttons.wk-flex container once <wishlist-button-product> mounts,
   so theme.css can hide its placeholder pill (desktop CLS fix). */
(function () {
  'use strict';
  function syncBadge() {
    var src = document.querySelector('.mobile-header-actions wishlist-link wk-counter');
    var n = src ? (src.textContent || '').trim() : '';
    document.querySelectorAll('.header-actions--buttons wishlist-link').forEach(function (l) {
      /* inline "(n)" after the label, matching the cart pill's "$x.xx (n)"
         format -- must live INSIDE the pill's <a> so it sits right after
         the "Wishlist" text and inherits font/color/hover inversion */
      var a = l.querySelector('a.wk-button') || l;
      var b = l.querySelector('.tz-wk-badge');
      if (!n || n === '0') { if (b) b.remove(); return; }
      if (!b) {
        b = document.createElement('span');
        b.className = 'tz-wk-badge';
        a.appendChild(b);
      }
      var txt = '(' + n + ')';
      if (b.textContent !== txt) b.textContent = txt;
    });
  }
  /* vendor -> collection URL, mirroring the theme's product-card logic:
     the card links product.metafields.custom.vendor_collection_url, else
     falls back to /collections/vendors?q=. This map was generated from
     that metafield (one sample product per vendor, 2026-07-21); vendors
     missing here get the same fallback the theme uses. Regenerate when
     new artist collections are added. */
  var TZ_VENDOR_COLLECTIONS = {"Antoku Kiln":"/collections/antoku-kiln","Arita Sansuien":"/collections/arita-sansuien","Asahiyaki":"/collections/asahi-yaki","Azuma Chaen":"/collections/azuma-chaen","Bashōen":"/collections/bashoen","Bifū Ceramics":"/collections/bifu-ceramics","Chaen Morifuku":"/collections/chaen-morifuku","Chikukaen":"/collections/chikukaen","Chikumeidō":"/collections/chikumeido","Eizan":"/collections/eizan","Enraku Kiln":"/collections/enraku-kiln","Eyuki Kiln":"/collections/eyuki-kiln","Fujimien":"/collections/fujimien","Fujita Tokuta":"/collections/fujita-tokuta","Genso":"/collections/genso-hozan-kiln","Genzō Kiln":"/collections/genzou-kiln","Gyokko":"/collections/gyokko-kiln","Gyokuryū":"/collections/gyokuryu-umehara","Hakusan":"/collections/hakusan","Hattori Seicha":"/collections/hattori-seicha","Hokuryū (Tatsuo Umehara)":"/collections/hokuryu","Hotta Takumi (Kenji Kiln)":"/collections/hotta-takumi","Hōzan Kiln":"/collections/genso-hozan-kiln","Igura Toshiya":"/collections/igura-toshiya","Ikeda Iki":"/collections/ikeda-iki","Isobe Teruyuki":"/collections/isobe-teruyuki","Isshin":"/collections/isshin","Itō Noriaka":"/collections/ito-noriaka","Itō Seiji":"/collections/ito-seiji-jinshu","Iwase Kōji":"/collections/iwase-koji","Kagoshima Seicha":"/collections/kagoshima-seicha","Kaji Shoten":"/collections/kaji-shoten","Karaku Kiln":"/collections/karaku-kiln","Katō Hiroshige (Kasen Kiln)":"/collections/kato-hiroshige-kasen-kiln","Katō Kazufusa":"/collections/kato-kazufusa","Katō Tatsutō":"/collections/kato-tatsuto","Kisen":"/collections/kisen","Kobayashi Lacquerware":"/collections/kobayashi-lacquerware","Kohokujō":"/collections/kohokujo","Komatsu Ken":"/collections/komatsu-ken","Kotodo":"/collections/kotodo","Kubo Tatehiro":"/collections/kubo-tatehiro","Kuramoto Masao":"/collections/kuramoto-masao","Kurokawa Masaki":"/collections/kurokawa-masaki","Kōzan Kiln":"/collections/kozan-kiln","Maekawa Junzō":"/collections/maekawa-junzo","Mano Shunen":"/collections/mano-shunen","Maruyasu Chagyo":"/collections/maruyasu-chagyo","Matsunaga Ceramics":"/collections/matsunaga-ceramics","Minoruen":"/collections/minoruen-chaho","Miyaji Eikō":"/collections/miyaji-eiko","Miyazakien":"/collections/miyazakien","Mizuno Hiroshi":"/collections/mizuno-hiroshi","Mori Iroku":"/collections/mori-iroku","Moriuchi Chanoen":"/collections/moriuchi-chanoen","Mukuhara Kashun":"/collections/tsubakihide-kiln","Murakami Iku":"/collections/murakami-iku","Murakoshi Fugetsu":"/collections/murakoshi-fugetsu","Murata Yoshiki":"/collections/murata-yoshiki","Nagayanagi Kousei":"/collections/nagayanagi-kousei","Nakamura Glass Studio":"/collections/nakamura-glass-studio","Nakamura Yohei":"/collections/nakamura-yohei","Ocha No Kajihara":"/collections/ocha-no-kajihara","Okayama Junzō":"/collections/okayama-junzo","Ono Shihō":"/collections/shiho-ono","Osada Seicha":"/collections/osada-seicha","Piece of Japan":"/collections/piece-of-japan","Reikō":"/collections/reiko","Rienzome":"/collections/rienzome","Rinzan Kiln":"/collections/rinzan-kiln","Rishouen":"/collections/rishouen","Ryōhō Kiln":"/collections/ryoho-kiln","Sawada Tomohiro":"/collections/sawada-tomohiro","Sekiryū Kiln":"/collections/sekiryu-kiln","Senryūzan Kiln":"/collections/senryuzan-kiln","Shiraiwa Taisuke":"/collections/shiraiwa-taisuke","Shōhō Kiln":"/collections/shoho-kiln","Shōjuen":"/collections/shojuen","Shōkakuen":"/collections/shokakuen","Shōraku":"/collections/shoraku-kiln","Shōryū Kiln":"/collections/shoryu-kiln","Sousouan":"/collections/sousouan","Sugawara Kengo":"/collections/sugawara-kengo","Sugita Takaaki (Kazami Kiln)":"/collections/sugita-takaaki-kazami-kiln","Suigetsu":"/collections/suigetsu","Suikaen":"/collections/suikaen","Tachi Masaki":"/collections/tachi-masaki","Takashima Shinichi":"/collections/takashima-shinichi","Tanaka Eikō":"/collections/tanaka-eiko","Tanaka Kōsen":"/collections/tanaka-kosen","Tanikawa Jin":"/collections/tanikawa-jin","Tanimura Tango":"/collections/tanimura-tango","Tanshin Kiln":"/collections/tanshin-kiln","Tomioka":"/collections/tomioka","Touan":"/collections/touan","Tsubakihide Kiln":"/collections/tsubakihide-kiln","Tsuzuki Seihō":"/collections/tsuzuki-seiho","Tsuzuki Yutaka":"/collections/tsuzuki-yutaka","Tōsen Kiln":"/collections/tosen-kiln","Uchiyama Chizuko":"/collections/uchiyama-chizuko","Yamadamatsu":"/collections/yamadamatsu","Yamaguchien":"/collections/yamaguchien","Yatsuyanagi":"/collections/yatsuyanagi","Yoshida Meichaen":"/collections/yoshida-meichaen","Yusen":"/collections/yusen"};
  var tzVendorCache = {};
  function injectVendors() {
    /* collection-card parity: vendor line above the title. The app's
       light-DOM card markup has no vendor, so fetch it per product
       (cached) from /products/<handle>.js */
    document.querySelectorAll('wishlist-page .wk-product-card').forEach(function (card) {
      /* product image + title links open in a new tab, like the vendor
         link, so the wishlist stays put while browsing */
      card.querySelectorAll('a[href*="/products/"]').forEach(function (pa) {
        if (pa.target !== '_blank') { pa.target = '_blank'; pa.rel = 'noopener'; }
      });
      if (card.querySelector('.tz-wk-vendor')) return;
      var title = card.querySelector('.wk-product-title');
      var link = card.querySelector('a[href*="/products/"]');
      if (!title || !link) return;
      var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle = m[1];
      var apply = function (vendor) {
        /* theme parity: no vendor line for "Various Artists" */
        if (!vendor || vendor === 'Various Artists' || card.querySelector('.tz-wk-vendor')) return;
        var v = document.createElement('div');
        v.className = 'tz-wk-vendor';
        var a = document.createElement('a');
        a.href = TZ_VENDOR_COLLECTIONS[vendor] || ('/collections/vendors?q=' + encodeURIComponent(vendor));
        a.target = '_blank';
        a.rel = 'noopener';
        a.textContent = vendor;
        v.appendChild(a);
        title.parentNode.insertBefore(v, title);
      };
      if (Object.prototype.hasOwnProperty.call(tzVendorCache, handle)) {
        apply(tzVendorCache[handle]);
        return;
      }
      tzVendorCache[handle] = null; /* in-flight marker */
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p) { tzProductCache[handle] = p; } /* full JSON, reused by STOQ notify */
          tzVendorCache[handle] = p && p.vendor ? p.vendor : '';
          apply(tzVendorCache[handle]);
        })
        .catch(function () { tzVendorCache[handle] = ''; });
    });
  }
  /* ---- FEATURE SIX: STOQ (Restock Rocket) back-in-stock signup for
     sold-out wishlist cards. STOQ's app embed skips app-proxy pages, so
     we bootstrap its own loader on demand by fetching /search (a page
     where the embed renders) and re-injecting its config + scripts -
     nothing hard-coded, always the shop's current STOQ config. Then
     window._RestockRocket.openModal(productData, variantId) gives the
     full saved-email signup UX (officially supported on non-product
     pages per STOQ's JS API docs). Fallback: open the product page. */
  var tzProductCache = {};
  var tzStoqBootStarted = false;
  function tzEnsureStoq() {
    return new Promise(function (resolve) {
      if (window._RestockRocket) { resolve(true); return; }
      if (!tzStoqBootStarted) {
        tzStoqBootStarted = true;
        fetch('/search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var cfg = doc.getElementById('RestockRocketConfig');
            if (!cfg) return;
            var s = document.createElement('script');
            s.id = 'RestockRocketConfig';
            s.textContent = cfg.textContent;
            document.head.appendChild(s);
            var st = doc.getElementById('RestockRocketStyle');
            if (st) {
              var se = document.createElement('style');
              se.id = 'RestockRocketStyle';
              se.textContent = st.textContent;
              document.head.appendChild(se);
            }
            doc.querySelectorAll('script[src]').forEach(function (sc) {
              if (/restockrocket|stoq/i.test(sc.getAttribute('src') || '')) {
                var e = document.createElement('script');
                e.src = sc.src;
                document.head.appendChild(e);
              }
            });
          })
          .catch(function () { /* fallback handles it */ });
      }
      var waited = 0;
      var iv = setInterval(function () {
        waited += 200;
        if (window._RestockRocket) { clearInterval(iv); resolve(true); }
        else if (waited >= 5000) { clearInterval(iv); resolve(false); }
      }, 200);
    });
  }
  function enhanceSoldOutCards() {
    document.querySelectorAll('wishlist-page .wk-product-card').forEach(function (card) {
      var btn = card.querySelector('.wk-cta-button');
      if (!btn) return;
      /* FLASH FIX (2026-08-24): while an add-to-cart is in flight the button
         is disabled ("Adding...") and the drawer opening fires this observer,
         which used to misread the disabled state as sold-out and flash the
         "Notify me when available" button for a beat. A busy flag on the
         button tells us it's mid-add, not sold out. */
      if (btn.dataset.tzAdding) return;
      var soldOut = btn.disabled || /sold out/i.test(btn.textContent || '');
      var existing = card.querySelector('.tz-wk-notify');
      if (!soldOut) {
        if (existing) { existing.remove(); btn.style.display = ''; }
        return;
      }
      if (existing) return;
      var link = card.querySelector('a[href*="/products/"]');
      var m = link && (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
      if (!m) return;
      var handle = m[1];
      var nb = document.createElement('button');
      nb.type = 'button';
      nb.className = 'tz-wk-notify';
      nb.textContent = 'Notify me when available';
      btn.style.display = 'none';
      btn.parentNode.insertBefore(nb, btn);
      nb.addEventListener('click', function () {
        var orig = nb.textContent;
        nb.disabled = true;
        nb.textContent = 'One moment...';
        var idInput = card.querySelector('input[name="id"]');
        tzEnsureStoq().then(function (ok) {
          nb.disabled = false;
          nb.textContent = orig;
          var p = tzProductCache[handle];
          if (ok && p && window._RestockRocket && typeof window._RestockRocket.openModal === 'function') {
            var variantId = (idInput && idInput.value) || (p.variants && p.variants[0] && p.variants[0].id);
            window._RestockRocket.openModal(p, String(variantId));
          } else {
            window.open('/products/' + handle, '_blank', 'noopener');
          }
        });
      });
    });
  }
  /* ---- ADAPTIVE HEART COLOR (Ryan 2026-08-24): the red outline heart
     disappears on dark product photos (wood table backgrounds). Sample the
     bottom-left corner of each card image - where the heart sits - and if
     it's dark, flip that card's heart to white via a CSS filter. Shopify's
     CDN sends CORS headers, so a crossOrigin probe canvas can read pixels;
     if anything fails we silently keep the default red. Results cached per
     image URL; re-classifies if the responsive currentSrc changes. */
  var tzLumaCache = {};
  function tzEnsureHeartStyle() {
    if (document.getElementById('tz-wk-heart-style')) return;
    var st = document.createElement('style');
    st.id = 'tz-wk-heart-style';
    st.textContent =
      '.tz-hover-qa.tz-wk-heart-light wk-button svg{' +
      'filter:brightness(0) invert(1) drop-shadow(0 1px 2px rgba(0,0,0,0.55));}';
    document.head.appendChild(st);
  }
  function tzClassifyHearts() {
    document.querySelectorAll('.product-item .tz-hover-qa').forEach(function (anchor) {
      var card = anchor.closest('.product-item');
      if (!card) return;
      var img = card.querySelector('img');
      if (!img) return;
      var src = img.currentSrc || img.src;
      if (!src || !img.complete) {
        if (!img.dataset.tzLumaWait) {
          img.dataset.tzLumaWait = '1';
          img.addEventListener('load', function () { delete anchor.dataset.tzLumaSrc; tzClassifyHearts(); }, { once: true });
        }
        return;
      }
      if (anchor.dataset.tzLumaSrc === src) return;
      anchor.dataset.tzLumaSrc = src;
      var apply = function (dark) { anchor.classList.toggle('tz-wk-heart-light', !!dark); };
      if (Object.prototype.hasOwnProperty.call(tzLumaCache, src)) { apply(tzLumaCache[src]); return; }
      var probe = new Image();
      probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        try {
          var s = 24;
          var c = document.createElement('canvas');
          c.width = s; c.height = s;
          var ctx = c.getContext('2d');
          /* bottom-left ~30% of the image = the heart's neighborhood */
          ctx.drawImage(probe, 0, probe.naturalHeight * 0.7, probe.naturalWidth * 0.3, probe.naturalHeight * 0.3, 0, 0, s, s);
          var d = ctx.getImageData(0, 0, s, s).data;
          var sum = 0;
          for (var i = 0; i < d.length; i += 4) sum += 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
          var dark = (sum / (s * s)) < 150;
          tzLumaCache[src] = dark;
          apply(dark);
        } catch (e) { /* CORS-tainted or decode issue: keep default red */ }
      };
      probe.onerror = function () { /* keep default */ };
      probe.src = src;
    });
  }
  function place() {
    syncBadge();
    injectVendors();
    enhanceSoldOutCards();
    tzEnsureHeartStyle();
    tzClassifyHearts();
    document.querySelectorAll('.product-item wishlist-button-collection').forEach(function (w) {
      var card = w.closest('.product-item');
      if (!card) return;
      var anchor = card.querySelector('.tz-hover-qa');
      if (!anchor) return;
      if (w.parentElement !== anchor) anchor.appendChild(w);
      var b = w.querySelector('wk-button');
      if (b && b.style.transform !== 'none') b.style.setProperty('transform', 'none', 'important');
      /* a11y 2026-10-20: the Wishlist King heart only announces "Wishlist"; give it the product name and a pressed state. */
      var wkBtn = w.querySelector('.wk-button');
      if (wkBtn) {
        var titleEl = card.querySelector('.product-item__title') || card.querySelector('.product-item__text a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
        var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
        var on = wkBtn.classList.contains('wk-selected');
        wkBtn.setAttribute('role', 'button');
        wkBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        wkBtn.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + (title || 'this product') + (on ? ' from wishlist' : ' to wishlist'));
      }
    });
    document.querySelectorAll('.flex-buttons.wk-flex').forEach(function (fb) {
      if (!fb.classList.contains('tz-wkp-loaded') && fb.querySelector('wishlist-button-product')) {
        fb.classList.add('tz-wkp-loaded');
      }
    });
  }
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.classList || !form.classList.contains('wk-form')) return;
    if (!form.closest('wishlist-page')) return;
    evt.preventDefault();
    evt.stopPropagation();
    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var btn = form.querySelector('.wk-cta-button');
    if (!idInput) return;
    var origLabel = btn ? btn.textContent : '';
    if (btn) { btn.dataset.tzAdding = '1'; btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: idInput.value, quantity: parseInt(qtyInput && qtyInput.value, 10) || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      /* PERCEIVED-SPEED FIX (2026-07-21): open the drawer IMMEDIATELY on
         add success instead of waiting for refreshCart()'s section
         re-render (~0.5s). The drawer opens with the old contents for a
         beat and refreshCart updates it in place - same pattern as the
         theme's own quick-add. */
      var sd = document.getElementById('site-cart-sidebar');
      if (sd && typeof sd.show === 'function') { sd.show(); }
      else {
        var h = document.querySelector('a[aria-controls="site-cart-sidebar"], .button--cart-handle');
        if (h) h.click();
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:added'));
      try { if (typeof window.refreshCart === 'function') window.refreshCart(); } catch (e) { /* no-op */ }
      if (btn) { btn.disabled = false; btn.textContent = origLabel; delete btn.dataset.tzAdding; }
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = origLabel; delete btn.dataset.tzAdding; }
      form.submit();
    });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', place);
  } else {
    place();
  }
  try {
    new MutationObserver(place).observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* no-op */ }
})();
